import React, { useState } from "react";
import { Box } from "@mui/material";
import { useMode } from "../../mode/ModeContext";
import { modes } from "../../mode/modes";
import { SimulationFormModel } from "../../types/forms";
import ExploreButton from "./ExploreButton";
import ManualModeButton from "./ManualModeButton";
import ExitModeDialog from "./ExitModeDialog";

interface ModeControlsProps {
  simulationFormModel: SimulationFormModel;
  showExploreButton?: boolean;
  showManualButton?: boolean;
}

export default function ModeControls({
  simulationFormModel,
  showExploreButton = true,
  showManualButton = true,
}: ModeControlsProps) {
  const { mode, setMode, exitToExplore } = useMode();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const hasSimulations = simulationFormModel.results.length > 0;

  if (mode === null) {
    return null;
  }

  const currentMode = modes[mode];
  const isManualMode = mode === "manual";

  const handleExplore = () => {
    // Session is already auto-saved to history, just exit
    exitToExplore();
  };

  const handleSwitchToManual = () => {
    if (hasSimulations) {
      setConfirmDialogOpen(true);
    } else {
      setMode("manual");
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {showExploreButton && <ExploreButton onExplore={handleExplore} />}
        {showManualButton && !isManualMode && hasSimulations && (
          <ManualModeButton onSwitchToManual={handleSwitchToManual} />
        )}
      </Box>

      <ExitModeDialog
        open={confirmDialogOpen}
        modeName={currentMode.label}
        onClose={() => setConfirmDialogOpen(false)}
        onConfirm={() => {
          setConfirmDialogOpen(false);
          setMode("manual");
        }}
      />
    </>
  );
}
